import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PublicChrome from './public/PublicChrome';
import BlurFade from './public/motion/BlurFade';
import NetworkGrid, { sortNetworks } from './public/NetworkGrid';

interface Project {
  _id: string;
  title: string;
  projectUrl: string;
  description: string;
  apy?: string;
  commission?: string;
  imageUrl?: string;
  minimumStake?: string;
  stakingLink?: string;
  tags?: string[];
}

const StakeListPage: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || window.location.origin;
        const stakeResponse = await axios.get(`${apiUrl}/api/projects?category=Stake`);
        if (stakeResponse.data.success) {
          setProjects(sortNetworks(stakeResponse.data.data.projects));
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  if (loading) {
    return (
      <PublicChrome>
        <div className="dusk-container py-24 text-center text-dusk-muted">Loading…</div>
      </PublicChrome>
    );
  }

  return (
    <PublicChrome>
      <section className="dusk-section border-b border-[var(--dusk-line)]">
        <div className="dusk-container max-w-3xl">
          <BlurFade>
            <h1 className="dusk-page-title text-[clamp(2rem,5vw,3.25rem)] m-0 mb-4 leading-tight">
              Stake the future.
            </h1>
            <p className="text-dusk-muted text-base leading-relaxed m-0 mb-2">
              Join DUSKPROOF — where decentralization meets automation.
            </p>
            <p className="text-dusk-muted text-base leading-relaxed m-0">
              We build, monitor, and scale validators across ecosystems — turning infrastructure into opportunity.
            </p>
          </BlurFade>
        </div>
      </section>

      <section id="staking" className="dusk-section">
        <div className="dusk-container">
          {projects.length === 0 ? (
            <p className="text-dusk-muted text-center">No staking services found.</p>
          ) : (
            <NetworkGrid items={projects} />
          )}
        </div>
      </section>
    </PublicChrome>
  );
};

export default StakeListPage;
